var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopmerchant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#008080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3545 11.2879C12.7864 10.9555 13.0023 10.7892 13.2516 10.6822C13.3646 10.6336 13.4821 10.5944 13.6027 10.5649C13.8687 10.5 14.1508 10.5 14.7149 10.5H18.2844C18.8485 10.5 19.1306 10.5 19.3966 10.5649C19.5172 10.5944 19.6347 10.6336 19.7478 10.6822C19.997 10.7892 20.213 10.9555 20.6449 11.2879C22.076 12.3897 22.7915 12.9405 23.0368 13.6539C23.1459 13.9712 23.1867 14.3049 23.1569 14.6364C23.0898 15.3818 22.525 16.064 21.3952 17.4283L18.7329 20.6435C17.7081 21.8812 17.1956 22.5 16.4997 22.5C15.8037 22.5 15.2913 21.8812 14.2665 20.6435L11.6041 17.4283C10.4744 16.064 9.90952 15.3818 9.84248 14.6364C9.81266 14.3049 9.85343 13.9712 9.96254 13.6539C10.2078 12.9405 10.9234 12.3897 12.3545 11.2879Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.166 14.167H17.8327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopmerchant);
export default __webpack_public_path__ + "static/media/topmerchant.7538c07dfc3c7566008123f9b1a27922.svg";
export { ForwardRef as ReactComponent };